'use client';

import Link from 'next/link';
import React from 'react';
import LikeButton from 'src/components/_common/Button/new/LikeButton';
import NextImage from 'src/components/_common/NextImage';
import { useSetOriginalsFavorMutation } from 'src/store/server/originals/originals.query';

import MyPickCardStyled from './MyPickCard.styled';

interface MyPickCardProps {
  originalsIdx: number;
  pickImage: string;
  pickName: string;
  linkUrl: string;
  backgroundColor: string;
}

const MyPickCard = ({ originalsIdx, pickImage, pickName, backgroundColor, linkUrl }: MyPickCardProps) => {
  const { mutate: setOriginalsFavorMutate } = useSetOriginalsFavorMutation({
    onSuccess: () => {
      // 성공 상황
    },
    onError: () => {
      // 에러 상황
    },
  });

  const handleToggleLike = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault(); // Link 이벤트 방지
    e.stopPropagation(); // 이벤트 버블링 방지

    setOriginalsFavorMutate({
      originalsIdx: originalsIdx,
      favorYN: 'N',
    });
  };

  return (
    <Link href={linkUrl} passHref legacyBehavior>
      <MyPickCardStyled.Container>
        {/* My Pick 이미지 */}
        <MyPickCardStyled.ImageWrapper>
          <NextImage
            src={pickImage}
            alt={`${pickName} Originals My Pick 이미지`}
            width={90}
            height={90}
            loading="eager"
            priority
          />
        </MyPickCardStyled.ImageWrapper>

        {/* My Pick 이름 & 좋아요 버튼 */}
        <MyPickCardStyled.MyPickInfoContainer $backgroundColor={backgroundColor}>
          <MyPickCardStyled.MyPickNameText>{pickName}</MyPickCardStyled.MyPickNameText>
          <LikeButton isActive={true} isAnimate={true} onClick={handleToggleLike}>
            {null}
          </LikeButton>
        </MyPickCardStyled.MyPickInfoContainer>
      </MyPickCardStyled.Container>
    </Link>
  );
};

export default MyPickCard;
